// @flow
import { useCallback, useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { stylesheet } from 'typestyle';

import LumeraPersistGate from '@components/LumeraPersistGate';

import DesignYourOwnRing from '@components/dyor/Container';

import Filters from '@components/diamondSearch/Filters';
import MarketingContent from '@components/diamondSearch/MarketingContent';

import PageSeoContentProvider from '../../PageSeoContentApplier';
import { CanonicalUrlProvider } from '../../../contexts/canonicalUrl';
import { SeoContentProvider } from '../../../contexts/seoContent';

import { looseSearchPath, searchPath } from '../../../app_routes/diamonds';

import type { RailsContextType } from '@types/misc';

type TProps = {
  dyor: boolean
};

const css = stylesheet({
  container: {
    width: '100%',
    overflow: 'hidden'
  },
  soldMessage: {
    marginLeft: 32,
    marginRight: 32
  }
});

const cssMarketingDescription = {
  marginTop: 20
};

function DiamondSoldMessage() {
  return (
    <p className={css.soldMessage}>
      The diamond you viewed previously has been purchased by another customer.
      Please select a similar diamond, below...
    </p>
  );
}

function DiamondNotFound({ dyor = true }: TProps) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: 'CLEAR_DIAMOND_SEARCH_FILTERS_CLICK',
      looseDiamonds: !dyor,
      disableUrlSync: true
    });
  }, [dispatch, dyor]);

  const handleFilterChange = useCallback(() => {
    if (typeof window === 'undefined') return;

    window.location = dyor ? searchPath() : looseSearchPath();
  }, [dyor]);

  return (
    <div className={css.container}>
      <DesignYourOwnRing withWrapper />
      <MarketingContent headerOnly />
      <DiamondSoldMessage />
      <Filters dyor={dyor} onFilterChange={handleFilterChange} disableUrlSync />
      <MarketingContent
        descriptionOnly
        descriptionStyles={cssMarketingDescription}
      />
    </div>
  );
}

export default (props: TProps, railsContext: RailsContextType) => {
  const store = ReactOnRails.getStore('SharedReduxStore');

  return (
    <Provider store={store}>
      <CanonicalUrlProvider debounceRate={50} forcedValue='/diamonds/search'>
        <SeoContentProvider>
          <PageSeoContentProvider>
            <LumeraPersistGate>
              <DiamondNotFound {...{ ...props, railsContext }} />
            </LumeraPersistGate>
          </PageSeoContentProvider>
        </SeoContentProvider>
      </CanonicalUrlProvider>
    </Provider>
  );
};
